import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-input__container" }
const _hoisted_2 = ["for"]

import { PropType, ref, watch } from "vue";
import { Uuid } from "@/code/Uuid";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressTextInput',
  props: {
  type: {
    type: String,
    default: "text",
  },
  name: String,
  placeholder: String,
  modelValue: String,
  disabled: Boolean,
  label: {
    type: String,
    required: true,
  },
  rules: {
    type: Object as PropType<object | string>,
    required: false,
  },
  maxlength: {
    type: Number,
    required: false,
  },
},
  emits: ["update:modelValue", "blur", "focus"],
  setup(__props, { emit }) {

const props = __props;


const active = ref<boolean>(!!props.modelValue);

const id = ref<string>(Uuid.newUuid());
const onInput = (event: Event) => {
  emit("update:modelValue", (event.target as HTMLInputElement).value);
};
const onFocus = (event: Event) => {
  active.value = true;
  emit("focus", (event.target as HTMLInputElement).value);
};
const onBlur = (event: Event) => {
  const value = (event.target as HTMLInputElement).value;
  if (!value) {
    active.value = false;
  }
  emit("blur", value);
};
watch(
  () => props.modelValue,
  (currVal) => {
    if (currVal) {
      active.value = true;
    } else {
      active.value = false;
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_message = _resolveComponent("v-message")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'text-input--active': active.value }, "text-input"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", { for: id.value }, [
        _renderSlot(_ctx.$slots, "label")
      ], 8, _hoisted_2),
      _createVNode(_component_v_field, {
        id: id.value,
        name: __props.name,
        type: __props.type,
        validateOnBlur: true,
        validateOnChange: false,
        validateOnInput: false,
        validateOnModelUpdate: false,
        onBlur: onBlur,
        onFocus: onFocus,
        onInput: onInput,
        label: __props.label,
        rules: __props.rules,
        disabled: __props.disabled,
        value: __props.modelValue,
        maxLength: __props.maxlength
      }, null, 8, ["id", "name", "type", "label", "rules", "disabled", "value", "maxLength"])
    ]),
    _createVNode(_component_v_message, {
      name: __props.name,
      class: "text-input__error-message"
    }, null, 8, ["name"])
  ], 2))
}
}

})